import i18n from '../i18n';

const lang = () => i18n.language || 'en';

export function fmtDate(input, opts) {
  if (input == null || input === '') return '—';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return '—';
    return new Intl.DateTimeFormat(lang(), opts ?? { dateStyle: 'medium', timeStyle: 'short' }).format(d);
  } catch {
    return '—';
  }
}

export function fmtDateShort(input) {
  return fmtDate(input, { day: '2-digit', month: 'short' });
}

export function fmtDateOnly(input) {
  return fmtDate(input, { day: '2-digit', month: 'short', year: 'numeric' });
}

export function fmtTime(input) {
  return fmtDate(input, { hour: '2-digit', minute: '2-digit' });
}

export function fmtNumber(n, opts) {
  if (n == null || Number.isNaN(n)) return '—';
  try {
    return new Intl.NumberFormat(lang(), opts).format(n);
  } catch {
    return String(n);
  }
}

export function fmtPercent(n, digits = 1) {
  if (n == null || Number.isNaN(n)) return '—';
  try {
    return new Intl.NumberFormat(lang(), {
      style: 'percent',
      maximumFractionDigits: digits,
    }).format(n);
  } catch {
    return `${(n * 100).toFixed(digits)}%`;
  }
}

export function fmtBytes(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let i = 0;
  let v = bytes;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${fmtNumber(v, { maximumFractionDigits: 1 })} ${units[i]}`;
}

export function fmtGb(val) {
  if (val == null || Number.isNaN(val)) return '—';
  if (val >= 1024) return `${fmtNumber(val / 1024, { maximumFractionDigits: 1 })} TB`;
  return `${fmtNumber(val, { maximumFractionDigits: 1 })} GB`;
}
